import React from 'react';
import { useSelector } from 'react-redux';
import { Grid, Typography } from '@mui/material';
import car from 'assets/images/CAR.svg';
import wheel from 'assets/images/carWheel.svg';
import checkList from 'assets/images/checklist.svg';
import fire from 'assets/images/fire-extinguisher.svg';
import aid from 'assets/images/first-aid-kit.svg';
import mechanical from 'assets/images/mechanical.svg';
import preformance from 'assets/images/performance.svg';

function AminitiesVehicle() {
  const vehicleInfoData = useSelector(
    (state) => state?.userVehicle?.userVehicle?.data
  );

  return (
    <div>
      <Grid container>
        {vehicleInfoData?.stepney && (
          <Grid
            item
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            md={3}
            sm={6}
            xs={12}
            className="p20 dashedBorderGrey"
          >
            <Grid item>
              <img src={wheel} alt="vehicle" className="width20 mr10" />
            </Grid>
            <Grid item>
              <Typography>Stepney</Typography>
              <Typography>{vehicleInfoData?.stepney}</Typography>
            </Grid>
          </Grid>
        )}
        {vehicleInfoData?.fireExtinguisher && (
          <Grid
            item
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            md={3}
            sm={6}
            xs={12}
            className="p20 dashedBorderGrey"
          >
            <Grid item>
              <img src={fire} alt="vehicle" className="width20 mr10" />
            </Grid>
            <Grid item>
              <Typography>Fire Extinguisher</Typography>
              <Typography>{vehicleInfoData?.fireExtinguisher}</Typography>
            </Grid>
          </Grid>
        )}
        {vehicleInfoData?.firstAid && (
          <Grid
            item
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            md={3}
            sm={6}
            xs={12}
            className="p20 dashedBorderGrey"
          >
            <Grid item>
              <img src={aid} alt="vehicle" className="width20 mr10" />
            </Grid>
            <Grid item>
              <Typography>firstAid</Typography>
              <Typography>{vehicleInfoData?.firstAid}</Typography>
            </Grid>
          </Grid>
        )}
        {vehicleInfoData?.lastInspection && (
          <Grid
            item
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            md={3}
            sm={6}
            xs={12}
            className="p20 dashedBorderGrey"
          >
            <Grid item>
              <img src={checkList} alt="vehicle" className="width20 mr10" />
            </Grid>
            <Grid item>
              <Typography>Last Inspection</Typography>
              <Typography>{vehicleInfoData?.lastInspection}</Typography>
            </Grid>
          </Grid>
        )}
        {vehicleInfoData?.lastService && (
          <Grid
            item
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            md={3}
            sm={6}
            xs={12}
            className="p20 dashedBorderGrey"
          >
            <Grid item>
              <img src={car} alt="vehicle" className="width20 mr10" />
            </Grid>
            <Grid item>
              <Typography>Last Service</Typography>
              <Typography>{vehicleInfoData?.lastService}</Typography>
            </Grid>
          </Grid>
        )}
      </Grid>
    </div>
  );
}

export default AminitiesVehicle;
